import Vue from 'vue'
import exchangeRateVue from './ExchangeRate.vue'

const defaultOptions = {
  // 公共参数
  type: 1, // 初始分类
  types: [1, 2], // 类型(1.按金额 2.按分期)
  dCurrency: '', // 初始化货币
  // 按金额
  iCurrency: '', // 当前货币(按金额)
  paymount: 0, // 当前金额
  minAmount: -Infinity, // 最小金额
  maxAmount: Infinity, // 最大金额
  rate: 1, // 汇率(HKD 1.00000)
  // 按分期
  nCurrency: '', // 当前货币(按分期))
  minterms: 0, // 最小分期
  maxterms: 0, // 最大分期
  terms: [], // 分期数组,
  needTips: false // 展示征费
}

let currentMsg, instance
const msgQueue = []
const ExchangeRateConstructor = Vue.extend(exchangeRateVue)

const defaultCallback = (data) => {
  if (currentMsg.resolve && currentMsg.reject) {
    if (data.action !== 'cancel') {
      currentMsg.resolve(data)
    } else {
      currentMsg.reject(data)
    }
  }
}

const initInstance = () => {
  instance = new ExchangeRateConstructor({
    el: document.createElement('div')
  })

  instance.callback = defaultCallback
}

const showNextMsg = () => {
  if (!instance) {
    initInstance()
  }

  if (!instance.value) {
    if (msgQueue.length > 0) {
      currentMsg = msgQueue.shift()

      const options = currentMsg.options
      for (const prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop]
        }
      }
      if (options.callback === undefined) {
        instance.callback = defaultCallback
      }
      document.body.appendChild(instance.$el)

      Vue.nextTick(() => {
        instance.value = true
      })
    }
  }
}

const ExchangeRate = options => {
  return new Promise((resolve, reject) => {
    msgQueue.push({
      options: Object.assign({}, defaultOptions, options),
      callback: defaultCallback,
      resolve,
      reject
    })

    showNextMsg()
  })
}

export default ExchangeRate
